import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UnespCoreAccessDeniedComponent, UnespCoreHomeComponent, UnespCorePageNotFoundComponent } from '@unesp/core'
import { UnespCoreAuthGuardService } from '@unesp/core'
import { environment } from 'src/environments/environment'

import { HomeComponent } from './modules/comum/home/home.component'
import { AjudaSuporteComponent } from './modules/comum/suporte/ajuda-suporte.component'
import { DownloadAssetComponent } from './modules/comum/download/download-asset.component'

import { DepartamentoInformacaoProcedimentoComponent } from './modules/departamento/departamento-informacao-procedimento/departamento-informacao-procedimento.component'
import { DepartamentoAprovarInscricaoComponent } from './modules/departamento/departamento-aprovar-inscricao/departamento-aprovar-inscricao.component'
import { DepartamentoAnalisarInscricaoComponent } from './modules/departamento/departamento-analisar-inscricao/departamento-analisar-inscricao.component'
import { DepartamentoLiberarDisciplinaComponent } from './modules/departamento/departamento-liberar-disciplina/departamento-liberar-disciplina.component'
import { DepartamentoAprovarPlanoComponent } from './modules/departamento/departamento-aprovar-plano/departamento-aprovar-plano.component'
import { DepartamentoAnalisarPlanoComponent } from './modules/departamento/departamento-analisar-plano/departamento-analisar-plano.component'
import { DepartamentoHomologarRelatorioComponent } from './modules/departamento/departamento-homologar-relatorio/departamento-homologar-relatorio.component'
import { DepartamentoAnalisarRelatorioComponent } from './modules/departamento/departamento-analisar-relatorio/departamento-analisar-relatorio.component'
import { DepartamentoPlanoEntregueComponent } from './modules/departamento/departamento-plano-entregue/departamento-plano-entregue.component'
import { DepartamentoRelatorioEntregueComponent } from './modules/departamento/departamento-relatorio-entregue/departamento-relatorio-entregue.component'
import { DepartamentoStatusInscritosComponent } from './modules/departamento/departamento-status-inscritos/departamento-status-inscritos.component'
import { DepartamentoDisciplinaLiberadaComponent } from './modules/departamento/departamento-disciplina-liberada/departamento-disciplina-liberada.component'

import { PropgStatusInscricaoComponent } from './modules/propg/propg-status-inscricao/propg-status-inscricao.component'
import { PropgListaPerfilComponent } from './modules/propg/perfis/lista-perfil/lista-perfil.component'
import { PropgListaPerfilPorUsuarioComponent } from './modules/propg/perfis/lista-perfil-por-usuario/lista-perfil-por-usuario.component'
import { PropgInscricoesComponent } from './modules/propg/propg-inscricoes/propg-inscricoes.component'
import { PropgAlunoPaadesComponent } from './modules/propg/propg-aluno-paades/propg-aluno-paades.component'
import { ConsultaLogComponent } from './modules/propg/consulta-log/consulta-log.component'

import { DiscenteInscricaoComponent } from './modules/discente/discente-inscricao/discente-inscricao.component'
import { DiscenteInformacaoProcedimentoComponent } from './modules/discente/discente-informacao-procedimento/discente-informacao-procedimento.component'
import { DiscenteCargaHorariaComponent } from './modules/discente/discente-carga-horaria/discente-carga-horaria.component'
import { DiscenteCargaHorariaPrevistaComponent } from './modules/discente/discente-carga-horaria-prevista/discente-carga-horaria-prevista.component'
import { DiscentePlanoAtividadeComponent } from './modules/discente/discente-plano-atividade/discente-plano-atividade.component'
import { DiscentePlanoAtividadeEntregarComponent } from './modules/discente/discente-plano-atividade-entregar/discente-plano-atividade-entregar.component'
import { DiscenteRelatorioAtividadeEntregarComponent } from './modules/discente/discente-relatorio-atividade-entregar/discente-relatorio-atividade-entregar.component'
import { DiscenteRelatorioAtividadeComponent } from './modules/discente/discente-relatorio-atividade/discente-relatorio-atividade.component'
import { DiscenteEmissaoCertificadoComponent } from './modules/discente/discente-emissao-certificado/discente-emissao-certificado.component'
import { DiscenteStatusInscricaoComponent } from './modules/discente/discente-status-inscricao/discente-status-inscricao.component'
import { DiscenteModeloPlanoAtividadesComponent } from './modules/discente/discente-modelo-plano-atividades/discente-modelo-plano-atividades.component'
import { DiscenteModeloRelatorioAtividadesComponent } from './modules/discente/discente-modelo-relatorio-atividades/discente-modelo-relatorio-atividades.component'

import { DocenteInformacaoProcedimentoComponent } from './modules/docente/docente-informacao-procedimento/docente-informacao-procedimento.component'
import { DocenteAprovarCargaHorariaComponent } from './modules/docente/docente-aprovar-carga-horaria/docente-aprovar-carga-horaria.component'
import { DocenteAprovarCargaHorariaEfetivaComponent } from './modules/docente/docente-aprovar-carga-horaria-efetiva/docente-aprovar-carga-horaria-efetiva.component'
import { DocenteAprovarRelatorioAtividadesComponent } from './modules/docente/docente-aprovar-relatorio-atividades/docente-aprovar-relatorio-atividades.component'
import { DocenteAnalisarRelatorioAtividadesComponent } from './modules/docente/docente-analisar-relatorio-atividades/docente-analisar-relatorio-atividades.component'
import { DocenteEmissaoCertificadoComponent } from './modules/docente/docente-emissao-certificado/docente-emissao-certificado.component'
import { DocentePlanoEntregueComponent } from './modules/docente/docente-plano-entregue/docente-plano-entregue.component'
import { DocenteRelatorioEntregueComponent } from './modules/docente/docente-relatorio-entregue/docente-relatorio-entregue.component'
import { DocenteStatusInscricaoComponent } from './modules/docente/docente-status-inscricao/docente-status-inscricao.component'

import { StpgStatusInscricaoComponent } from './modules/stpg/stpg-status-inscricao/stpg-status-inscricao.component'
import { StpgInscricoesComponent } from './modules/stpg/stpg-inscricoes/stpg-inscricoes.component'

import { ConsultaStatusInscricaoComponent } from './modules/consulta/consulta-status-inscricao/consulta-status-inscricao.component'

import { CentralAcessosHomeComponent } from './modules/comum/central-acessos-home/central-acessos-home.component'
import { NormasComponent } from './modules/comum/normas/normas.component'
import { CertificadoValidadorComponent } from './modules/comum/certificado-validador/certificado-validador.component'
import { PesquisaUsuarioComponent } from './modules/propg/pesquisa-usuario/pesquisa-usuario.component'
import { PesquisaDepartamentoComponent } from './modules/propg/pesquisa-departamento/pesquisa-departamento.component'

const routes: Routes = [
  // COMUMN
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'access-denied',
    component: UnespCoreAccessDeniedComponent,
  },
  {
    path: 'auth',
    component: UnespCoreHomeComponent,
  },
  {
    path: 'page-not-found',
    component: UnespCorePageNotFoundComponent,
  },
  {
    path: 'ajuda/suporte',
    component: AjudaSuporteComponent,
  },
  // DEPARTAMENTO
  {
    path: 'departamento/informacao-procedimento',
    component: DepartamentoInformacaoProcedimentoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/liberar-disciplina',
    component: DepartamentoLiberarDisciplinaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/aprovar-inscricao',
    component: DepartamentoAprovarInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/analisar-inscricao/:id',
    component: DepartamentoAnalisarInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/aprovar-plano',
    component: DepartamentoAprovarPlanoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/aprovar-plano/:id',
    component: DepartamentoAnalisarPlanoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/homologar-relatorio',
    component: DepartamentoHomologarRelatorioComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/homologar-relatorio/:id',
    component: DepartamentoAnalisarRelatorioComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/plano-entregue',
    component: DepartamentoPlanoEntregueComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/relatorio-entregue',
    component: DepartamentoRelatorioEntregueComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/status-inscritos',
    component: DepartamentoStatusInscritosComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  {
    path: 'departamento/disciplina-liberada',
    component: DepartamentoDisciplinaLiberadaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`, `${environment.roles.ASSESSOR.name}`],
    },
  },
  // PROPG
  {
    path: 'propg/status-inscricao',
    component: PropgStatusInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/inscricoes',
    component: PropgInscricoesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/aluno-paades',
    component: PropgAlunoPaadesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/pesquisa-usuario',
    component: PesquisaUsuarioComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/pesquisa-departamento',
    component: PesquisaDepartamentoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/perfil',
    component: PropgListaPerfilComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/perfil/:identificacao',
    component: PropgListaPerfilPorUsuarioComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  {
    path: 'propg/consulta-log',
    component: ConsultaLogComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  // DISCENTE
  {
    path: 'discente/informacao-procedimento',
    component: DiscenteInformacaoProcedimentoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/inscricao',
    component: DiscenteInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/modelo-plano-atividades',
    component: DiscenteModeloPlanoAtividadesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/modelo-relatorio-atividades',
    component: DiscenteModeloRelatorioAtividadesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/carga-horaria',
    component: DiscenteCargaHorariaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/carga-horaria/:id',
    component: DiscenteCargaHorariaPrevistaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/entregar-plano-atividade',
    component: DiscentePlanoAtividadeComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/entregar-plano-atividade/:id',
    component: DiscentePlanoAtividadeEntregarComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/entregar-relatorio-atividade',
    component: DiscenteRelatorioAtividadeComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/entregar-relatorio-atividade/:id',
    component: DiscenteRelatorioAtividadeEntregarComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/emissao-certificado',
    component: DiscenteEmissaoCertificadoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'discente/status-inscricao',
    component: DiscenteStatusInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  // DOCENTE
  {
    path: 'docente/informacao-procedimento',
    component: DocenteInformacaoProcedimentoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/aprovar-carga-horaria',
    component: DocenteAprovarCargaHorariaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/aprovar-carga-horaria/:id',
    component: DocenteAprovarCargaHorariaEfetivaComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/aprovar-relatorio-atividades',
    component: DocenteAprovarRelatorioAtividadesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/aprovar-relatorio-atividades/:id',
    component: DocenteAnalisarRelatorioAtividadesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/emissao-certificado',
    component: DocenteEmissaoCertificadoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/plano-entregue',
    component: DocentePlanoEntregueComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/relatorio-entregue',
    component: DocenteRelatorioEntregueComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'docente/status-inscricao',
    component: DocenteStatusInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  // STPG
  {
    path: 'stpg/inscricoes',
    component: StpgInscricoesComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.STPG.name}`],
    },
  },
  {
    path: 'stpg/status-inscricao',
    component: StpgStatusInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.STPG.name}`],
    },
  },
  // CONSULTA
  {
    path: 'consulta/status-inscricao',
    component: ConsultaStatusInscricaoComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.CONSULTA.name}`],
    },
  },
  // MANUAIS
  {
    path: 'manual/departamento',
    component: DownloadAssetComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      filename: 'manual-departamento.pdf',
      title: 'Manual departamento',
      viewer: true,
      allowedRoles: [`${environment.roles.DEPARTAMENTO.name}`],
    },
  },
  {
    path: 'manual/discente',
    component: DownloadAssetComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      filename: 'manual-discente.pdf',
      title: 'Manual discente',
      viewer: true,
      allowedRoles: [`${environment.roles.DISCENTE.name}`],
    },
  },
  {
    path: 'manual/docente',
    component: DownloadAssetComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      filename: 'manual-docente.pdf',
      title: 'Manual docente',
      viewer: true,
      allowedRoles: [`${environment.roles.DOCENTE.name}`],
    },
  },
  {
    path: 'manual/stpg',
    component: DownloadAssetComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      filename: 'manual-stpg.pdf',
      title: 'Manual STPG',
      viewer: true,
      allowedRoles: [`${environment.roles.STPG.name}`],
    },
  },
  {
    path: 'manual/propg',
    component: DownloadAssetComponent,
    canActivate: [UnespCoreAuthGuardService],
    data: {
      filename: 'manual-propg.pdf',
      title: 'Manual PROPG',
      viewer: true,
      allowedRoles: [`${environment.roles.PROPG.name}`],
    },
  },
  // COMUMN
  {
    path: 'changelog',
    loadComponent: () => import('./modules/comum/changelog/changelog.component').then(m => m.ChangeLogComponent),
  },
  {
    path: 'ajuda/guia',
    component: DownloadAssetComponent,
    data: {
      filename: 'guia-paades.pdf',
      title: 'Guia',
      viewer: true,
    },
  },
  {
    path: 'normas',
    component: NormasComponent,
  },
  {
    path: 'autenticidade-certificado',
    component: CertificadoValidadorComponent,
  },
  {
    path: 'autenticidade-certificado/:codigo',
    component: CertificadoValidadorComponent,
  },
  {
    path: 'central-acessos-home',
    component: CentralAcessosHomeComponent,
  },
  {
    path: '**',
    redirectTo: '/page-not-found',
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
